// extracted by mini-css-extract-plugin
export var arrows = "_6x-6";
export var decrementer = "_6x-a";
export var disabled = "_6x-4";
export var error = "_6x-1";
export var hiddenText = "_6x-b";
export var incrementer = "_6x-9";
export var input = "_6x-8";
export var inputWrapper = "_6x-0";
export var leadingIcon = "_6x-c";
export var readonly = "_6x-3";
export var regular = "_6x-7";
export var small = "_6x-5";
export var warning = "_6x-2";